module.exports = __webpack_public_path__ + "static/3_mobile-2a2dfef0eb71f11de7c362d03c16904a.jpg";